module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wedding-hairmakerehearsal-ecd3e09ba6c361207c2fc3a0b6e8b2ad.png";